import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import TableWithFrontPaginationDesign from "@/components/base/table/TableWithFrontPaginationDesign.vue";
import { OfferSingle } from "@/services/offers/OfferSingle";
import { IOfferMetric } from "@/api/types/offers";
import { formatDurationShort } from "@/utils/formatDates";

interface Props {
    offer: OfferSingle
}
interface IGetItems {
    period: string
    metrics_averages: IOfferMetric
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OfferMetricsTable',
  props: {
    offer: null
  },
  setup(__props: any) {

const props = __props as {
    offer: OfferSingle
}



const headers = [
    { text: 'Период', sortable: false, value: 'period' },
    { text: 'CRu,%', sortable: false, value: 'metrics_averages.mt_cr_u' },
    { text: 'CRt,%', sortable: false, value: 'metrics_averages.mt_cr_t' },
    { text: 'EPCt', sortable: false, value: 'metrics_averages.mt_epc_t' },
    { text: 'EPCu', sortable: false, value: 'metrics_averages.mt_epc_u' },
    { text: 'AR,%', sortable: false, value: 'metrics_averages.mt_ar' },
    { text: 'EPL', sortable: false, value: 'metrics_averages.mt_epl' },
    { text: 'Период аппрува', sortable: false, value: 'metrics_averages.mt_approval_time', tooltip: 'Время от конверсии до апрува.', tooltipWidth: 'fit-content' },
    { text: 'Период продажи', sortable: false, value: 'metrics_averages.mt_sale_time', tooltip: 'Время с даты клика до даты конверсии за 2 недели.' },
];

const uniqueData = ['mt_approval_time', 'mt_sale_time'].map(key => ({
    slot: `item.metrics_averages.${key}`,
    template: (item: IGetItems): string => formatDurationShort(item.metrics_averages[key]),
}));

const getItems = computed<IGetItems[]>(() => {
    const mt: IOfferMetric = props.offer.metrics_detailed;

    return Object.keys(mt).map(el => ({
        period: translatePeriod(el),
        metrics_averages: Object.keys(mt[el]).reduce((acc, e) => {
            acc[`mt_${e}`] = mt[el][e];
            return acc;
        }, {}),
    }));
});

const translatePeriod = (name: string) => {
    switch (name) {
    case 'today': return 'Сегодня';
    case 'yesterday': return 'Вчера';
    case 'days7': return '7 дней';
    case 'days14': return '14 дней';
    case 'days30': return '30 дней';
    }
};

return { __sfc: true,props, headers, uniqueData, getItems, translatePeriod, TableWithFrontPaginationDesign }
}

})